import type { ArrowData, Level } from './types';

/** Gaps are traversable space; an arrow leaves at the board's outer edge. */
export function arrowExitDistance(arrow: ArrowData, board: Pick<Level, 'width' | 'height'>): number {
  const head = arrow.cells[arrow.cells.length - 1];
  switch (arrow.direction) {
    case 'UP': return head!.y + .5;
    case 'DOWN': return board.height - head!.y - .5;
    case 'LEFT': return head!.x + .5;
    case 'RIGHT': return board.width - head!.x - .5;
  }
}
